// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var contactMe = "ContactMe-module--contact-me--NHZ20";
export var contactMeTextWrapper = "ContactMe-module--contact-me-text-wrapper--22mqE";
export var contactMeText = "ContactMe-module--contact-me-text--3XYEJ";
export var contactMeButton = "ContactMe-module--contact-me-button--379oN";
export var gradient = "ContactMe-module--gradient--dJ5PJ";
export var minorPulse = "ContactMe-module--minor-pulse--nzFIJ";